import Vue from 'vue'
import '../newsletter-form/newsletter-form.vue'
import '../picture/picture.vue'

export default el => new Vue({
  name: 'Email Collection',
  el
})